<div class="container">
	<input #input type="text" (input)="onInput(input.value)" placeholder="Поиск" i18n-placeholder>
</div>
<ul *ngIf="!loading" #ul (scroll)="onScroll(ul.scrollHeight, ul.scrollTop, ul.clientHeight)">
	<li *ngFor="let item of list" (click)="select(item)" [class.not-selected-mode]="mode === 'VIEW'">
		<span class="item-name">{{ dataType === "STORAGES" ? item[0].storageName : joinFelds(item[0]) }}</span>
		<span>{{ dataType === "STORAGES" ? item[0].addressFull : checkCountryProvider(item) }}</span>
		<span class="item-gln">{{ checkGln(item) }}</span>
	</li>
</ul>
<div *ngIf="loading" class="loader-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>
